import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import type { FunctionComponent } from 'react';

import { useEntityChangeGlimmer } from './use-entity-change-glimmer';

// Transient overlay that briefly shimmers over its nearest positioned ancestor
// when the agent updates the given entity (see use-entity-change-glimmer).
// Render it inside a `relative` container covering the surface to highlight.
// Pass entityId=undefined to disable (e.g. while the surface is being edited).
export const AgentChangeGlimmer: FunctionComponent<{
    readonly className?: string;
    readonly entityId: string | undefined;
}> = ({ className, entityId }) => {
    const isGlimmering = useEntityChangeGlimmer(entityId);

    return (
        <AnimatePresence>
            {isGlimmering ? (
                <motion.div
                    animate={{ opacity: 1 }}
                    className={clsx(
                        'pointer-events-none absolute inset-0 z-10 rounded-recessed-pocket',
                        'animate-shimmer bg-linear-to-r from-transparent via-white/60 to-transparent [background-size:1000px_100%]',
                        'motion-reduce:animate-none motion-reduce:bg-white/25 motion-reduce:bg-none',
                        className,
                    )}
                    data-testid="agent-change-glimmer"
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    transition={{ duration: 0.25, ease: 'easeOut' }}
                />
            ) : null}
        </AnimatePresence>
    );
};
